module.exports = __webpack_public_path__ + "static/media/addworkout.0ea110ef.mov";